import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';

export class VotesCount extends Field {
  static attributesForModel() {
    return ['votes'];
  }

  get title() {
    return 'Votes count';
  }

  exampleContents(): FieldContentsData {
    return { text: 3, icon: { name: 'fa-regular fa-badge-check' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (typeof record.votes === 'number') {
      return {
        text: record.votes,
        icon: { name: 'fa-regular fa-badge-check' },
      };
    }

    return {};
  }
}
